import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import './LensBuilder.scss';
import LensBuilderType from '../../../types/lens-builder.type';

import { getCurrentOrder } from '../../../store/slices/order.slice';

import FrameInfo from './frame-info/FrameInfo';
import VisionNeed from './vision-need/VisionNeed';
import LensPackage from './lens-package/LensPackage';
import Prescription from './prescription/Prescription';

import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';

interface ReactParams {
  id: string;
}

const LensBuilder = () => {
  const { id } = useParams<ReactParams>();
  const { step, order } = useSelector(getCurrentOrder);

  const renderLensOrder = () => {
    switch (step) {
      case LensBuilderType.VISION_NEED:
        return <VisionNeed />;
      case LensBuilderType.LENS_PACKAGE:
        return <LensPackage />;
      case LensBuilderType.PRESCRIPTION:
        return <Prescription />;
      case LensBuilderType.PRESCRIPTION_ONLY: {
        return <Prescription isRxOnly={true} />;
      }
      default: {
        return <FrameInfo modelCode={id} />;
      }
    }
  };

  return (
    <div className="lens-builder">
      <Breadcrumbs order={order}></Breadcrumbs>
      <div className="lens-builder__wrapper">{renderLensOrder()}</div>
    </div>
  );
};

export default LensBuilder;
